(function ($) {
    $( document ).ready(function() {
        $('#toggle-advent-calendar-style').on('click', function(){
            if($('#advent-calendar').hasClass('barrier-free')){
                $('#advent-calendar').removeClass('barrier-free');
                $('#toggle-advent-calendar-style').text('Barrierefreie Darstellung aktivieren');
            } else {
                $('#advent-calendar').addClass('barrier-free');
                $('#toggle-advent-calendar-style').text('Barrierefreie Darstellung deaktivieren');
            }
        });
    });
})(jQuery);
